import { DataTypes, Op } from '../utils/DataTypes';
import AppModel from '../core/AppModel';
import Helper from '../core/Helper';
import Schema from '../core/Schema';

export default class Salida extends AppModel {
  constructor(sequelize, origin,crud) {
    super(sequelize, origin,crud);
    this.atributos = {
			id: {
        allowNull: false,
        autoIncrement: true,
        primaryKey: true,
        type: DataTypes['INTEGER']
      },
      surtido_id: {
				allowNull: false,
        type: DataTypes['INTEGER'],
      },
      insumo_id: {
				allowNull: false,
        type: DataTypes['INTEGER'],
      },
      cantidad: {
				allowNull: false,
        type: DataTypes['FLOAT'],
			},
      created_at: {
        allowNull: false,
        type: DataTypes['DATE'],
      },
		};
		this.fieldsValids = Object.keys(this.atributos);
		this.options = {
      tableName: 'salidas',
			modelName: 'Salida',
			timestamps: false,
			freezeTableName: true,
			underscored: true,
      // Hooks: https://sequelize.org/master/manual/hooks.html
    };
    if(this.crud) {
			this.model = sequelize.define(this.options.modelName, this.atributos, this.options);
		}
  }// constructor.
  
  includeAssociations() {
		return [
			{model: this.sequelize.models.Surtido, as : 's_surtido'},
			{model: this.sequelize.models.Insumo, as : 's_insumo'}
		];
	}
	
}
